import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {AllLabels, InstallationFlowType} from '../../../../constants/app.constants';
import {AllDropdownKeys} from '../../../jurisdiction.constants';
import {TechnicianDataService} from '../../technician-data.service';
import {KeyValueData} from '../../../../domains/common.domain';
import {LookupOptionsData} from '../../../jurisdiction.domain';
import {CommonService} from '../../../../services/common.service';
import {LocalStorageService} from '../../../../services/local-storage.service';

@Component({
  selector: 'app-special-consumers',
  styleUrls: ['./special-consumers.component.scss'],
  templateUrl: './special-consumers.component.html',
})

export class SpecialConsumersComponent implements OnChanges, OnInit {
  @Input() specialDeviceData: any = null;
  @Output() deleteComponent: EventEmitter<number>;
  @Input() isReadOnly: boolean = false;

  componentIndex: number;
  currentInstallationFlow: string;
  installationFlowType: KeyValueData;
  specialDeviceKey: string;
  specialDeviceType: string;
  specialDeviceFG: FormGroup;
  specialDevices: LookupOptionsData[];
  unitLabels: KeyValueData;

  constructor(
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private technicianDataService: TechnicianDataService,
  ) {
    this.currentInstallationFlow = this.localStorageService.getItem('installation_flow');
    this.deleteComponent = new EventEmitter<number>();
  }

  ngOnInit(): void {
    this.specialDeviceKey = (this.currentInstallationFlow === InstallationFlowType.TemporaryConnection)
    || (this.currentInstallationFlow === InstallationFlowType.ChangeHouseConnection)
      ? AllDropdownKeys.TempSpecialConsumerType
      : AllDropdownKeys.SpecialConsumerType;
    this.installationFlowType = InstallationFlowType;

    this.specialDevices = this.commonService.getDropdownData(this.specialDeviceKey);
    this.unitLabels = AllLabels.units;

    this.initializeData();

    this.technicianDataService.registerForActionOnFormSubmit.subscribe(
      (value: boolean) => {
        if (value) {
          this.resetData();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.specialDeviceData && !changes.specialDeviceData.firstChange) {
      this.initializeData();
    }
  }

  selectSpecialDevice(event: any = null): void {
    if (event) {
      this.specialDeviceType = event.value;
    }
    if (this.specialDeviceType === 'other') {
      this.specialDeviceFG.addControl('otherType',
        new FormControl(this.specialDeviceData?.otherType || '', [Validators.required]));
      this.specialDeviceFG.controls.otherType.markAsTouched();
    } else {
      this.specialDeviceFG.removeControl('otherType');
    }
    if (this.specialDeviceType === 'wallbox' || this.specialDeviceType === 'charger') {
      this.specialDeviceFG.addControl('consumptionDeviceCheckbox',
        new FormControl(!event ? this.specialDeviceData?.consumptionDeviceCheckbox : false));
      this.specialDeviceFG.addControl('publicDeviceCheckbox',
        new FormControl(!event ? this.specialDeviceData?.publicDeviceCheckbox : false));
    } else {
      this.specialDeviceFG.removeControl('consumptionDeviceCheckbox');
      this.specialDeviceFG.removeControl('publicDeviceCheckbox');
    }
  }

  removeElement(): void {
    this.deleteComponent.emit(this.componentIndex);
  }

  private prepareForm(): void {
    const selectedDevice = this.specialDeviceData && this.specialDeviceData.device
      && this.specialDevices.filter(
        (item) => item.value === this.specialDeviceData.device)[0] || null;
    this.specialDeviceType = selectedDevice && selectedDevice.value || '';

    this.specialDeviceFG = new FormGroup({
      device: new FormControl(this.specialDeviceType,
        [Validators.required]),
      count: new FormControl(this.specialDeviceData?.count || '',
        [Validators.required]),
      power: new FormControl(this.specialDeviceData?.power || '',
        [Validators.required]),
      id: new FormControl(this.specialDeviceData?.id || ''),
    });

    if (this.currentInstallationFlow !== this.installationFlowType.TemporaryConnection) {
      this.specialDeviceFG.addControl('description',
        new FormControl(this.specialDeviceData && this.specialDeviceData.description || ''));
    }

    if (this.specialDeviceType) {
      this.selectSpecialDevice();
    }
  }

  private initializeData(): void {
    this.prepareForm();

    this.componentIndex = this.technicianDataService.specialDeviceCount;
    this.technicianDataService.manageSpecialConsumersFormData({
      component: 'specialDevice',
      formData: this.specialDeviceFG,
      index: this.componentIndex,
    });
  }

  private resetData(): void {
    this.componentIndex = 0;
    this.specialDeviceType = '';
  }
}

